import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router';
import fakeData from 'features/IRWorkstation/constants/fakeData';

const countBadgeStyles = {
	red: { bg: 'status.red.bg', color: 'status.red.text' },
	amber: { bg: 'status.amber.bg', color: 'status.amber.text' },
	gray: { bg: 'status.gray.bg', color: 'status.gray.text' },
	vdr: { bg: 'vdr.bg', color: 'vdr.text' },
};

const Sidebar = () => {
	const navigate = useNavigate();
	const { sidebarSections } = fakeData;

	return (
		<Box
			sx={{
				width: 200,
				flexShrink: 0,
				backgroundColor: 'background.paper',
				borderRight: '0.5px solid',
				borderColor: 'border.light',
				overflowY: 'auto',
				py: '12px',
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			{sidebarSections.map((section) => (
				<Box key={section.label} sx={{ mb: '18px' }}>
					<Typography
						variant='overline'
						sx={{
							display: 'block',
							color: section.vdr ? 'vdr.text' : 'text.tertiary',
							padding: '0 14px 5px',
						}}
					>
						{section.label}
					</Typography>
					{section.items.map((item) => (
						<Box
							key={item.name}
							sx={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-between',
								padding: '6px 14px',
								cursor: 'pointer',
								borderLeft: item.defaultActive
									? '2px solid'
									: '2px solid transparent',
								borderLeftColor: item.defaultActive
									? 'primary.main'
									: 'transparent',
								backgroundColor: item.defaultActive
									? 'background.subtle'
									: 'transparent',
								'&:hover': {
									backgroundColor: item.vdr ? 'vdr.bg' : 'background.subtle',
								},
							}}
						>
							<Typography
								sx={{
									fontSize: '12px',
									fontWeight: item.defaultActive ? 600 : 500,
									color: item.vdr
										? 'vdr.text'
										: item.defaultActive
											? 'text.primary'
											: 'text.secondary',
								}}
							>
								{item.name}
							</Typography>
							{item.count !== undefined && (
								<Box
									component='span'
									sx={{
										fontSize: '10px',
										fontWeight: 600,
										padding: '2px 6px',
										borderRadius: '9px',
										backgroundColor: (
											countBadgeStyles[item.countColor] || countBadgeStyles.gray
										).bg,
										color: (
											countBadgeStyles[item.countColor] || countBadgeStyles.gray
										).color,
									}}
								>
									{item.count}
								</Box>
							)}
						</Box>
					))}
				</Box>
			))}
			<Box sx={{ flex: 1 }} />
			<Box sx={{ p: '12px' }}>
				<Button
					variant='filled'
					onClick={() => {
						navigate('/');
					}}
					sx={{
						width: '100%',
						height: '40px',
						backgroundColor: 'background.subtle',
						color: 'status.red.text',
						'&:hover': {
							border: '1px solid',
							borderColor: 'status.red.text',
							backgroundColor: 'status.red.bg',
						},
					}}
				>
					Back to Launchpad
				</Button>
			</Box>
		</Box>
	);
};

export default Sidebar;
